import { useState } from 'react';
import { useTranslation } from '@shared/core';

type FallbackNoteParams = Readonly<{
  firstPartner: string;
  secondPartner?: string | null;
  from: string;
}>;

type GiftNoteFallback = Readonly<{
  partners: string;
  fallbackNote: string;
}>;

export const useGiftWrapNoteFallback = ({ firstPartner, secondPartner, from }: FallbackNoteParams): GiftNoteFallback => {
  const { tq } = useTranslation('giftNoteGuest');

  const messages = [
    () => tq`Wishing you joy and happiness on this special occasion. Hope you love this gift!`,
    () => tq`Congratulations on your special day! I'm so excited for you and hope this brings many wonderful moments.`,
    () => tq`Sending you warm wishes and lots of love. I hope this gift adds to the joy of your celebration!`,
    () => tq`So happy to celebrate with you! Wishing you all the best and hope you enjoy this gift.`,
  ];
  const [messageIndex] = useState(() => Math.floor(Math.random() * messages.length));

  const partners = (secondPartner ? tq`${firstPartner} and ${secondPartner}` : firstPartner) || tq`the couple`;
  const message = messages[messageIndex]();

  return {
    partners,
    fallbackNote: `${tq`Dear ${partners},`}

${message}

${tq`Warmly,`}
${from}`,
  };
};
